// extracted by mini-css-extract-plugin
module.exports = {"reportLink":"ReportLink_reportLink__2g_yq","reportInfo":"ReportLink_reportInfo__3Z7sZ","title":"ReportLink_title__1Ozmq"};